import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import { useNavigate, useParams } from 'react-router-dom'
import { message } from 'antd'
import Dropdown from 'meinian-package/src/baseComponent/dropdown'
import Upload from 'meinian-package/src/component/upload/image'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import { Ul, Li } from 'meinian-package/src/baseComponent'
import { sampleHasAuth } from 'meinian-package/src/utils/auth'
import classNames from 'classnames'
import { request } from 'meinian-package/src/utils'
import setFolder from '../../../../../component/useFunModal/setFolder'
import moreFolderModalFun from '../../../../../component/useFunModal/moveFolder'
import './index.less'

export default ({ data, onUpdate, onDataChange, parent, className = undefined, tree = [] }) => {
  const { folderId } = useParams()
  const history = useNavigate()
  const afterUpload = (file) => {
    request.post('/zhikuan/mn/sample/folder/update-folder', { ...data, coverUrl: file[0]?.url }).then(result => {
      if (result) {
        onUpdate({ coverUrl: file[0].url })
        message.success('设置封面成功')
      }
    })
  }

  const onDelete = async () => {
    const result = await request.get('/zhikuan/mn/sample/folder/delete-folder', { params: { folderId: data.id } })
    if (result) {
      onDataChange?.()
      message.success('删除成功')
      const curItem = tree.find(item => item.value == folderId)
      if (curItem && curItem.parent?.value) {
        history(`/home/sample/${curItem.parent.value}`)
      } else {
        history('/home/sample')
      }
    }
  }
  const onMove = async (_id) => {
    const result = await request.post('/zhikuan/mn/sample/folder/move-folder', { toFolderId: _id, folderIdList: [data.id] })
    if (result) {
      onDataChange?.()
      message.success('移动成功')
    }
  }
  const menu = (<Ul
    style={{ width: 152 }}
    ulProps={
    {
      onClick: e => e.stopPropagation()
    }
  }
  >
    {
      sampleHasAuth('createAndUpdateFolder') && <Li
        className="mn-dropdown-icon-li"
        onClick={() => {
          setFolder?.({
            title: '编辑文件夹',
            type: 'edit',
            value: { folderName: data?.folderName, remark: data?.remark, id: data.id },
            onOk: (val) => {
              onUpdate(val)
            }
          })
        }}
      ><Icon type="m-bianji" />编辑</Li>
    }
    {
       sampleHasAuth('createAndUpdateFolder') && <Li className="mn-dropdown-icon-li">
         <Upload onSuccess={afterUpload}>
           <Icon type="m-chuntumoshi" />设置封面
         </Upload>
       </Li>
    }
    {
      !parent && folderId && sampleHasAuth('moveAndDeleteFolder') && <Li
        className="mn-dropdown-icon-li"
        onClick={() => {
          moreFolderModalFun?.({
            type: 'folder',
            createFolderAuth: sampleHasAuth('createAndUpdateFolder'),
            onOk: (curData, val) => {
              onMove(val)
              onDataChange?.()
            }
          })
        }}
      ><Icon type="m-yidong" />移动</Li>
    }
    {
      sampleHasAuth('moveAndDeleteFolder') && <>
        <div className="li-partition" />
        <Li
          className="mn-dropdown-icon-li delete"
          onClick={() => {
            ModalConfirm.show({
              title: '确认删除文件夹？',
              content: '当文件夹被删除后，文件夹下内容将一并删除，不可恢复',
              onOk: () => {
                onDelete()
                onDataChange?.()
              }
            })
          }}
        ><Icon type="m-shanchu" />删除</Li>
      </>
    }
  </Ul>)

  return <Dropdown
    trigger="hover"
    placement="bottomRight"
    className="mn-card-more-options"
    getPopupContainer={(triggerNode) => triggerNode.parentNode || document.body}
    overlay={menu}
  >
    <div className={classNames('mn-child-file-card-more-btn', className)}>
      <Icon type="m-gengduo" />
    </div>
  </Dropdown>
}
